<template>
  <div class="home">
    <!-- 曜阳养老期待你的加入 start -->
    <div class="join section">
      <div class="section_title">
        <h2>曜阳养老期待你的加入</h2>
        <p>—— 每时每刻，您都看得到我们的成长 ——</p>
      </div>
      <div class="join_content">
        <el-row :gutter="40" type="flex" class="row-bg" justify="center">
          <el-col :sm="6" :md="4">
            <div class="join_item">
              <div class="item_img">
                <img src="../assets/志愿者.png" alt="" />
              </div>
              <div class="join_text">
                <p>志愿者</p>
                <h3>38568<span> 人</span></h3>
              </div>
            </div>
          </el-col>
          <el-col :sm="6" :md="4">
            <div class="join_item">
              <div class="item_img">
                <img src="../assets/志愿组织.png" alt="" />
              </div>
              <div class="join_text">
                <p>志愿组织</p>
                <h3>5<span> 个</span></h3>
              </div>
            </div>
          </el-col>
          <el-col :sm="6" :md="4">
            <div class="join_item">
              <div class="item_img">
                <img src="../assets/养老机构.png" alt="" />
              </div>
              <div class="join_text">
                <p>养老机构</p>
                <h3>11<span> 家</span></h3>
              </div>
            </div>
          </el-col>
          <!-- <el-col :sm="6" :md="4">
            <div class="join_item">
              <div class="item_img">
                <img src="../assets/服务时长.png" alt="">
              </div>
              <div class="join_text">
                <p>服务时长</p>
                <h3>7<span> 小时</span></h3>
              </div>
            </div>
          </el-col> -->
        </el-row>
      </div>
    </div>
    <!-- 曜阳养老期待你的加入 end -->
    <!-- 轮播图 start -->
    <!-- <div class="carousel">
      <el-carousel trigger="click" height="500px">
        <el-carousel-item>
          <img src="../assets/banner01.jpg" alt />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner02.jpg" alt />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner03.jpg" alt />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner04.jpg" alt />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner05.jpg" alt />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner06.jpg" alt />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner07.jpg" alt />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <!-- 轮播图 end -->
    <!-- 活动风采
         start -->
    <div class="news section">
      <div class="news_title section_title">
        <h2>活动风采</h2>
        <p>—— ACTIVITY ——</p>
      </div>
      <el-row :gutter="20">
        <el-col :sm="24" :md="12">
          <div class="img_news">
            <el-carousel height="410px" direction="vertical" autop>
              <el-carousel-item
                v-if="index <= 2"
                v-for="(item, index) in activityList"
                :key="item.id"
              >
                <div class="img_news_box" @click="activityDetail(item.id)">
                  <img :src="baseurl + item.img" alt="" />
                  <div class="box_title">
                    <p class="text_of">{{ item.title }}</p>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="text_news">
            <div class="text_title">
              <h3>活动风采</h3>
              <h4 @click="moreActivity('')">MORE+</h4>
            </div>
            <div class="text_list">
              <ul>
                <li
                  v-for="(item, index) in activityList"
                  :key="item.id"
                  @click="activityDetail(item.id)"
                >
                  <p>
                    <span class="iconfont iconwenzhang"></span
                    >{{ item.title }}
                  </p>
                  <span>{{ item.createDate.split(" ")[0] }}</span>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 活动风采 end -->
    <!-- 新闻 start -->
    <div class="news section">
      <div class="news_title section_title">
        <h2>通知公告</h2>
        <p>—— ACTIVITY ——</p>
      </div>
      <el-row :gutter="20">
        <el-col :sm="24" :md="12">
          <div class="img_news">
            <el-carousel height="410px" direction="vertical" autop>
              <el-carousel-item
                v-if="index <= 2"
                v-for="(item, index) in noticeList"
                :key="item.id"
              >
                <div class="img_news_box" @click="activityDetail(item.id)">
                  <img :src="baseurl + item.img" alt="" />
                  <div class="box_title">
                    <p class="text_of">{{ item.title }}</p>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="text_news">
            <div class="text_title">
              <h3>通知公告</h3>
              <h4 @click="moreActivity(39)">MORE+</h4>
            </div>
            <div class="text_list">
              <ul>
                <li
                  v-for="(item, index) in noticeList"
                  :key="item.id"
                  @click="activityDetail(item.id)"
                >
                  <p>
                    <span class="iconfont iconwenzhang"></span
                    >{{ item.title }}
                  </p>
                  <span>{{ item.createDate.split(" ")[0] }}</span>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 新闻 end -->
    
    <!-- 活动类型 start -->
    <div class="activity section">
      <div class="section_title">
        <h2>志愿者活动类型</h2>
        <p>—— 了解活动类型精准帮扶 ——</p>
      </div>
      <div class="activity_content">
        <div class="content_item">
          <!-- @click="goActivityList(33) -->

          <div class="item_box">
            <img src="../assets/101.png" alt="" />
            <div class="box_title">
              <p>法律咨询</p>
            </div>
          </div>
        </div>
        <div class="content_item">
          <!-- @click="goActivityList(34)" -->
          <div class="item_box">
            <img src="../assets/102.png" alt="" />
            <div class="box_title">
              <p>健康指导</p>
            </div>
          </div>
        </div>
        <div class="content_item">
          <!-- @click="goActivityList(35)" -->
          <div class="item_box">
            <img src="../assets/103.png" alt="" />
            <div class="box_title">
              <p>精神慰藉</p>
            </div>
          </div>
        </div>
        <div class="content_item">
          <!-- @click="goActivityList(36)" -->
          <div class="item_box">
            <img src="../assets/104.png" alt="" />
            <div class="box_title">
              <p>生活照料</p>
            </div>
          </div>
        </div>
        <div class="content_item">
          <!-- @click="goActivityList(37)" -->

          <div class="item_box">
            <img src="../assets/105.png" alt="" />
            <div class="box_title">
              <p>文化生活</p>
            </div>
          </div>
        </div>
        <div class="content_item">
          <!-- @click="goActivityList(38)" -->

          <div class="item_box">
            <img src="../assets/106.png" alt="" />
            <div class="box_title">
              <p>专业服务</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 活动类型 end -->
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      baseurl: this.$baseurl,
      activityList: [],
      typeList: [],
      noticeList: [],
    };
  },
  mounted() {
    this.getActivityList().then((res) => {
      console.log(res)
      this.activityList = res;
    });
    this.getActivityList(39).then((res) => {
      this.noticeList = res;
    });
    this.gettype();
  },
  methods: {
    goActivityList(id) {
      this.$emit("routerchange", "/activity");
      this.$router.push({ path: "/activity", query: { id } });
    },
    async gettype() {
      let {
        data: { data, code },
      } = await this.$http.get("api/publishtype/selectAll");
      if (code != 0) return;
      this.typeList = data;
    },
    activityDetail(id) {
      this.$router.push({ path: "/noticeDetail", query: { id } });
    },
    moreActivity(type) {
      this.$emit("routerchange", "/activity");
      this.$router.push("/activity?id="+type);
    },
    async getActivityList(type) {
      console.log(this.dataform);
      let {
        data: { code, data },
      } = await this.$http.get("/api/information/page", {
        params: { page: 1, limit: 10, type:type,status:2 },
      });
      console.log(data);
      if (code != 0) return;
      return data.list;
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  .carousel {
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .section {
    padding: 30px 50px 30px;
    &_title {
      text-align: center;
      padding-bottom: 40px;
      h2 {
        font-weight: 300;
        line-height: 1.5;
      }
      p {
        color: rgb(153, 153, 153);
      }
    }
  }
  .news {
    .img_news {
      .img_news_box {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: pointer;
        .box_title {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 50px;
          line-height: 45px;
          padding: 0 10px;
          color: #fff;
          background-color: rgba(19, 19, 19, 0.6);
          p {
            padding-right: 40px;
          }
        }
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }
    .text_news {
      .text_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-bottom: 2px solid rgb(207, 206, 206);
        h3 {
          font-weight: 300;
          border-left: 4px solid #de010e;
          padding-left: 5px;
        }
        h4 {
          border: 1px solid #de010e;
          font-weight: 300;
          padding: 3px;
          color: #de010e;
        }
      }
      .text_list {
        ul {
          li {
            padding: 0 5px;
            cursor: pointer;
            position: relative;
            display: flex;
            justify-content: space-between;
            line-height: 50px;
            transition: all 0.3s ease-in-out;
            p {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 20px;
              span {
                font-size: 22px;
                padding-right: 5px;
                color: #de010e;
              }
            }
            &::after {
              position: absolute;
              bottom: 0;
              left: 0;
              content: "";
              width: 30px;
              border-bottom: 1px solid #37474f;
              transition: all 0.3s ease-in-out;
            }
            &:hover {
              background-color: #ebedf0;
              &::after {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  .join {
    background-color: #f5f5f5;
    .join_item {
      .item_img {
        width: 100%;
        height: 100px;
        padding: 20px 0;
        text-align: center;
        img {
          height: 100%;
          width: auto;
        }
      }
      .join_text {
        text-align: center;
        h3 {
          font-size: 40px;
          font-weight: 400;
          line-height: 1.5;
          span {
            font-size: 16px;
          }
        }
      }
    }
  }
  .activity {
    .activity_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .content_item {
        flex: 1;
        padding: 10px;
        cursor: pointer;
        .item_box {
          position: relative;
          top: 0;
          width: 100%;
          height: 300px;
          border: 1px solid rgb(224, 219, 219);
          overflow: hidden;
          transition: 0.2s ease-out;
          &:hover {
            top: -10px;
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          img {
            height: 100%;
            width: 100%;
            object-fit: cover;
          }
          .box_title {
            position: absolute;
            width: 100%;
            line-height: 34px;
            left: 0;
            bottom: 0;
            color: #fff;
            background-color: rgba(19, 19, 19, 0.6);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>